var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ResultsGrid"},_vm._l((_vm.resultsItems),function(item,index){return _c('GridItem',{key:'gridItem-' + index,attrs:{"item":item}})}))}
var staticRenderFns = []

export { render, staticRenderFns }